let config;

if (process.env.NODE_ENV === "production"){
    config = {
        loginUrl : "https://order.b2b.schuberth.com",
        cookieDomain: "order.b2b.schuberth.com",
        alwaysShowNavbar: false,
        APIURL: "https://prod.api.schuberth.info",
        DEALERAPI: "https://prod.api.schuberth.com",
        isDevSystem: false
    }

/*if (process.env.NODE_ENV === "production"){
    config = {
        loginUrl : "http://svxdocker-dev:50812",
        cookieDomain: "svxdocker-dev:50812",
        alwaysShowNavbar: false,
        APIURL: "http://dev.api.schuberth.local",
        DEALERAPI: "https://prod.api.schuberth.com",
        isDevSystem: true
    }
}*/
}
else {
    config = {
        loginUrl : "http://localhost:8080",
        cookieDomain: "localhost",
        alwaysShowNavbar: false,
        APIURL: "http://dev.api.schuberth.local",
        DEALERAPI: "https://prod.api.schuberth.com",
        isDevSystem: true
    }
}


export { config }